import { InspectionCase, SummaryNotes } from './inspection-cases';
import { InspectionWaterNetworkCase } from './inspection-cases/inspection-water-network-case.dto';
import { Cases, Inspection } from './inspection.dto';

export class WaterNetworkCharacterizationDto extends InspectionCase {
  testData?: InspectionWaterNetworkCase[];
  summaryNotes?: SummaryNotes[];
}

export class WaterNetworkCharacterization
  extends WaterNetworkCharacterizationDto
  implements Inspection
{
  constructor(
    data: WaterNetworkCharacterizationDto = {
      isApplicable: false,
      summaryNotes: []
    }
  ) {
    super(data);
    this.title = 'אופיין רשת מים';
    this.summaryNotes = data.summaryNotes;
    this.testData = data.testData
      ? data.testData.map((item) => new InspectionWaterNetworkCase(item))
      : [new InspectionWaterNetworkCase()];
  }

  setInspectionStatus(): void {
    this.isPassed = !this.isApplicable || this._isPassed();
  }

  getCases(): Cases[] {
    return [];
  }

  private _isPassed?(): boolean {
    return !this.testData.some((test) => test.isApplicable && !test.isPassed);
  }
}
